const loopSwiper = new Swiper(".p-loopSlider", {
  speed: 5000, // スライド変化時間
  loop: true,
  loopAdditionalSlides: 1,
  slidesPerView: 'auto',
  spaceBetween: 20,
  autoplay: {
    delay: 0, //　スライダー表示時間
  },
});